<template>
  <div class>
    <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="handleChangeDrawer">
      <div slot="body">
        <div class="pay-mains">
            <div class="totals-box pl24 mt20">
              <div class="flex-row mb30">
                <div class="itemName">审核状态</div>
                <div class="itemNum jishi">{{ form.auditStatusCn }}</div>
              </div>
              <div class="flex-row mb30">
                <div class="itemName">申请时间</div>
                <div class="itemNum">{{ formatDate(form.applyTime) }}</div>
              </div>
              <div class="flex-row mb30">
                <div class="itemName">发票时间</div>
                <div class="itemNum">{{ formatDate(form.invoiceTime) }}</div>
              </div>
              <div class="flex-row mb30" v-if="invoiceFlag == 'yes'">
                <div class="itemName">开支日期起</div>
                <div class="itemNum">{{ form.beginTime ? formatDay(form.beginTime):'' }}</div>
              </div>
              <div class="flex-row mb30" v-if="invoiceFlag == 'yes'">
                <div class="itemName">开支日期止</div>
                <div class="itemNum">{{ form.endTime ? formatDay(form.endTime):'' }}</div>
              </div>
              <div class="flex-row mb30">
                <div class="itemName">开支类型</div>
                <div class="itemNum">{{ form.categoryIdCn }}</div>
              </div>
              <div class="flex-row mb30">
                <div class="itemName">费用明细</div>
                <div class="itemNum" style="line-height: 1; white-space:normal;word-break:break-all;word-wrap:break-word;">{{ form.applyRemark }}</div>
              </div>
              <div class="flex-row mb30">
                <div class="itemName">申请金额</div>
                <div class="itemNum">￥{{ form.amount ? form.amount : 0 }}</div>
              </div>
              <div class="flex-row mb30">
                <div class="itemName">审核金额</div>
                <div class="itemNum">￥{{ form.auditAmount ? form.auditAmount : 0 }}</div>
              </div>
              <div class="flex-row mb30" v-if="form.imgUrlList.length > 0 && imgHide == 'enable'">
                <div class="itemName">发票照片</div>
                <el-image
                  class="img"
                  v-for="(item,index) in form.imgUrlList"
                  :src="item"
                  :key="index"
                  :preview-src-list="previewList"
                  @click="handPreview(item)"
                ></el-image>
              </div>
            </div>
            <p class="order-title-boxs" v-if="form.reportShopMealDayList.length > 0"><span class="blueBlock"></span><i>费用明细</i></p>
            <div class="mb30 plr24" v-if="form.reportShopMealDayList.length > 0">
              <el-table :data="form.reportShopMealDayList" max-height="300" show-summary :summary-method="getSummaries" header-cell-class-name="table_header_bgcolor">
                <el-table-column prop="reportDate" width="auto" label="日期">
                  <template slot-scope="scope">
                    <span>{{formatDay(scope.row.reportDate)}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="staffNumber" width="auto" label="在店人数" align="center"></el-table-column>
                <el-table-column prop="equipmentCookFlagCn" width="auto" label="是否有厨师" align="center"></el-table-column>
                <el-table-column prop="amount" width="auto" label="金额" align="center"></el-table-column>
              </el-table>
            </div>
            <p class="order-title-boxs" v-if="form.invoiceLogVOList.length > 0"><span class="blueBlock"></span><i>审核流程</i></p>
            <div class="audit-boxs" v-if="form.invoiceLogVOList.length > 0 ">
              <div v-for="(item,index) in form.invoiceLogVOList" :key="index" class="group-list">
                <div class="totals-box pl24 mt20">
                  <div class="flex-row mb30">
                    <div class="itemName">{{ item.nodeName?item.nodeName:'' }}</div>
                    <div :class="item.auditStatus == 'refuse'?'success':'wait'">{{ item.auditStatusCn }}</div>
                  </div>
                  <div class="flex-row mb30">
                    <div class="itemName">审核人</div>
                    <div>{{ item.auditOpIdCn?item.auditOpIdCn:'' }}</div>
                  </div>
                  <div class="flex-row mb30">
                    <div class="itemName">审核时间</div>
                    <div class="time">{{ item.auditTime?formatDate(item.auditTime):'' }}</div>
                  </div>
                  <div class="flex-row mb30">
                    <div class="itemName">审核金额</div>
                    <div class="moneys">￥{{ item.auditAmount }}</div>
                  </div>
                </div>
              </div>
            </div>
        </div>
        <div class="drawer-footer">
          <div class="btns pr24 pb10">
            <el-button type="warning" v-if="form.cancelFlag" v-perm="{key: 'invoice', value: 'invoice:cancel'}" @click="calcel">撤销</el-button>
            <el-button type="primary" v-if="form.editFlag" v-perm="{key: 'invoice', value: 'invoice:edit'}" @click="addClick">修改</el-button>
          </div>
        </div>
      </div>
    </drawer>
    <edit-set ref="editSetForm" @change="handleEditChange"></edit-set>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import drawer from "../../../components/common/drawer";
import editSet from "./edit";
export default {
  mixins: [minxin],
  components: { drawer,editSet },
  data() {
    return {
      radio: 0,
      addEditTitle: "开支明细",
      addEditShow: false,
      imgHide: '', //图片隐藏
      invoiceFlag: '',
      optionsHide: false,
      options: [],

      form: {
        categoryId: "",
        amount: "",
        applyRemark: "",
        invoiceLogVOList: [],
        imgUrlList: [],
        reportShopMealDayList: []
      },
      orderInvalidForm: {},
      previewList: []
    };
  },
  created() {
    this.editInit();
  },
  methods: {
    back() {
      //   this.$router.push("/collectMoney");
      this.addEditShow = false;
    },
    editInit() {
      this.$on("set", function(org) {
        Object.assign(this.$data, this.$options.data());
        this.addEditShow = true;
        this.$api.get(this.$url.invoice.get, {
            id: org.id
          })
          .then(res => {
            if (res) {
              this.form = res;
              this.form.oxCtime = this.formatDate(this.form.oxCtime);
                this.invoiceCategory();
            }
          });
      });
    },
    handPreview (url) {
      let imgUrl = []
      this.previewList = []
      if (url.indexOf("?") > -1) {
        let arr = url.split("?")
        imgUrl.push(arr[0])
      } else {
        imgUrl.push(url)
      }
      this.previewList = imgUrl
      console.log(this.previewList);
    },
    addClick() {
        this.$refs["editSetForm"].$emit("set", this.form)
    },
    invoiceCategory() {
      //发票分类
      this.$api.post(this.$url.invoiceCategory.list).then(res => {
        if (res) {
          this.options = res;
          this.optionsHide = true;
          this.setImgHide();
        }
      });
    },
    calcel() {
      this.$confirm("确定撤销?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$api.get(this.$url.invoice.cancel, {
              id: this.form.id
            })
            .then(res => {
              if (res) {
                this.addEditShow = false;
                this.$emit("change", true);
              }
            });
        })
        .catch(() => {});
    },
    setImgHide() {
      let res = this.options.find(p => p.id == this.form.categoryId)
      if (res) {
        this.imgHide = res.needImg;
        this.invoiceFlag = res.invoiceDayFlag;
      }
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (index == columns.length - 1) {
          const values = data.map(item => Number(item[column.property]));
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
        }
      });
      return sums;
    },
    handleEditChange (org) {
        if (org) {
            this.$emit("change", true);
            this.$api.get(this.$url.invoice.get, {
            id: this.form.id
          })
          .then(res => {
            if (res) {
              this.form = res;
              this.form.oxCtime = this.formatDate(this.form.oxCtime);
                this.formHide = true;
                this.setImgHide();
            }
          });
        } 
    },
    handleChangeDrawer() {
      this.addEditShow = false;
      this.$emit("change", false);
    }
  }
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
.pay-mains {
  padding: 0;
  /deep/ .el-form-item__content {
    width: 200px !important;
    // display: flex;
    .el-form-item__error {
      right: 0;
    }
  }
  /deep/ .el-form {
    padding-bottom: 20px;
    .audit-title {
      border-top: 10px solid @borderColor;
    }
    /deep/ .el-form-item {
      border-bottom: 1px solid @borderColor;
      margin-bottom: 0;
      // &:last-child {
      //   border-bottom: 0;
      // }
    }
    .img-item {
      margin: 10px 0 0 0;
      font-size: 16px;
      padding: 0 26px;
      border-bottom: 0;
    }
    .img-item .el-form-item__content {
      width: calc(100% - 120px) !important;
    }
    .el-form-item-img {
      border-bottom: 0;
    }
    .el-form-item-update {
      padding: 0 26px;
      height: 46px;
      align-items: center;
      display: flex;
      margin: 0;
      // justify-content: space-between;
      border-bottom: 1px solid @borderColor;
      /deep/ .el-form-item__label {
        font-size: 16px;
        font-weight: 500;
        color: #333;
        // text-align: left;
      }
      /deep/ .el-form-item__content {
        flex: 2;
        text-align: right;
        // display: flex;
        .el-form-item__error {
          right: 0;
        }
      }
      /deep/ .el-input__inner {
        height: 46px;
        
        padding: 0;
        text-align: right;
      }
      /deep/.el-select .el-input__inner {
        padding: 0 30px;
      }
      /deep/ .el-radio__inner {
        width: 22px;
        height: 22px;
      }
      /deep/ .el-radio__label {
        font-size: 16px;
      }

      /deep/ .el-input.is-disabled .el-input__inner {
        background: #fff;
      }
      /deep/ .el-link {
        width: 160px;
      }
      .money {
        color: @money;
      }
    }
    .el-form-item-remark {
      height: auto;
      min-height: 46px;
      /deep/ .el-form-item__content {
        margin-left: 0 !important;
        line-height: 1;
      }
    }
  }
}
.group-list {
  color: #111;
  border-bottom: 1px solid @borderColor;
  .list-left {
    .text {
      margin-right: 40px;
    }
    .time {
      margin-top: 10px;
    }
  }
  .list-right {
    .success {
      color: #57a900;
    }
    .wait {
      color: @blue;
    }
    .money {
      color: @money;
      margin-top: 10px;
    }
  }
}
.img {
  width: 80px;
  height: 80px;
  margin-right: 10px;
}
// .pay-mains {
//   .img {
//     width: 80px;
//     height: 80px;
//     margin: 0 10px 10px 0;
//   }
// }
</style>